import { render, staticRenderFns } from "./FormColorField.vue?vue&type=template&id=1ccc814f"
import script from "./FormColorField.vue?vue&type=script&lang=js"
export * from "./FormColorField.vue?vue&type=script&lang=js"
import style0 from "./FormColorField.vue?vue&type=style&index=0&id=1ccc814f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports